import React, { input, useState, useEffect} from "react";
import { Button, Form } from 'react-bootstrap';
import { FaTimes, FaExpandAlt, FaWindowMinimize, FaTrash, FaUnderline, FaPaperclip, FaLink} from 'react-icons/fa';

export default function InboxNewMessageModal({setShowResults}) {
  const [isOpen, setIsOpen] = useState(false)
    useEffect(() => {
      document.body.classList.toggle('modal-open', isOpen);
    },[isOpen])
    
    const onClickClose = () => setShowResults();

  return (
    <div className="message-container">  
      <div className="message-header-box">
        <h4>New Message</h4>
        <div className="messages-modal-actions">
          {/* <Button className="btn" onCLick={()=> setIsOpen(!isOpen)}>
            <FaWindowMinimize />
          </Button>
          <Button className="btn">
            <FaExpandAlt />
          </Button> */}
          <Button className="btn" onClick={onClickClose}>
            <FaTimes />
          </Button>
        </div>
      </div>
      <div className="message-body">
        <div className="recipients">
          <Form.Control type="email" placeholder="Recipients" />
        </div>
        <div className="subject">        
        <Form.Control type="text" placeholder="Subject" />
        </div>
        <div className="main-message-box">
       <p> Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam, eaque ipsa quae ab illo inventore veritatis et quasi architecto beatae vitae dicta sunt explicabo. Nemo enim ipsam voluptatem quia voluptas sit aspernatur aut odit aut fugit, sed quia consequuntur magni dolores eos qui ratione voluptatem sequi nesciunt. Neque porro quisquam est, qui dolorem ipsum quia dolor sit amet, consectetur, adipisci velit, sed quia non numquam eius modi tempora incidunt ut labore et dolore magnam aliquam quaerat voluptatem. Ut enim ad minima veniam, quis nostrum exercitationem ullam corporis suscipit laboriosam, nisi ut aliquid ex ea commodi consequatur? Quis autem vel eum iure reprehenderit qui in ea voluptate velit esse quam nihil molestiae consequatur, vel illum qui dolorem eum fugiat quo voluptas nulla pariatur?</p>
       <p> Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam, eaque ipsa quae ab illo inventore veritatis et quasi architecto beatae vitae dicta sunt explicabo. Nemo enim ipsam voluptatem quia voluptas sit aspernatur aut odit aut fugit, sed quia consequuntur magni dolores eos qui ratione voluptatem sequi nesciunt. Neque porro quisquam est, qui dolorem ipsum quia dolor sit amet, consectetur, adipisci velit, sed quia non numquam eius modi tempora incidunt ut labore et dolore magnam aliquam quaerat voluptatem. Ut enim ad minima veniam, quis nostrum exercitationem ullam corporis suscipit laboriosam, nisi ut aliquid ex ea commodi consequatur? Quis autem vel eum iure reprehenderit qui in ea voluptate velit esse quam nihil molestiae consequatur, vel illum qui dolorem eum fugiat quo voluptas nulla pariatur?</p>
        </div>       
      </div>
      <div className="message-footer">
       <div className="other-actions">       
        <Button className="btn-send" variant="warning">
          Send
        </Button>
        <Button className="btn-format" variant="outline-secondary">
          <FaUnderline />
        </Button>
        <Button className="btn-format" variant="outline-secondary">
          <FaPaperclip />
        </Button>
          <Button className="btn-format" variant="outline-secondary">
          <FaLink />
        </Button>
       </div>
       <div className="delete-action">
        <Button className="btn-detele" variant="outline-secondary">
          <FaTrash />
        </Button>
       </div>
      </div>           
  </div>
  );
}
// export default InboxNewMessageModal;
